import styled, { css } from 'styled-components';

type TextProps = {
  marginTop?: number;
};

export const Text = styled.span<TextProps>`
  ${({ theme, marginTop }) => css`
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: ${theme.colors.statusDanger30};

    display: block;

    margin-top: ${marginTop}px;

    > button {
      color: ${theme.colors.statusDanger30};
      border-color: ${theme.colors.statusDanger30};

      &:hover {
        color: ${theme.colors.statusDanger30};
      }
    }
  `}
`;
